import React, { Fragment, useState, useEffect } from 'react';
import cn from './../../../../lib/bem';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  getParametrosSimulacion,
  resetConsultarDatos,
} from './../../../../redux/reducers/simuladorFVGSlice';
import {
  obtenerFechaActual,
  capitalizarPalabras,
  formatAmount,
} from './../../../../lib/utils';
import ico_description from './../../../../assets/svg/ico_description.svg';
import ico_inventory from './../../../../assets/svg/ico_inventory.svg';
import ico_mail from './../../../../assets/svg/ico_mail.svg';
import LinkComponent from './../../../../components/Link/link_component';
import TooltipComponent from './../../../../components/tooltip/tooltip_component';
import MonedaSelectComponent from './../../../../components/monedaSelect/monedaSelect_component';
import MontoInputComponent from './../../../../components/montoInput/montoInput_component';
import PlazoInputComponent from './../../../../components/plazoInput/plazoInput_component';
import LayoutSimuladorComponent from './../../components/layoutSimulador/layoutSimulador_Component';
import ModalConfirmarCorreoComponent from './../../components/modalConfirmarCorreo/modalConfirmarCorreo_Component';
import ModalNotasImportantesComponent from './../../components/modalNotasImportantes/modalNotasImportantes_Component';
import PDF_Coberturas_FVG from './../../../../assets/pdf/PDF_Coberturas_FVG.pdf';

import './simulador_fvg.scss';
import ButtonIconComponent from '../../../../components/buttonIcon/buttonIcon_component';

const SimuladorFVG = () => {
  const classes = cn('simuladorFVG');
  const history = useNavigate();
  const dispatch = useDispatch();

  const [mostrarModalCorreo, setMostrarModalCorreo] = useState(false);
  const [mostratModalNotasI, setMostratModalNotasI] = useState(false);

  const simuladorFVG = useSelector((state) => state.rootReducers.simuladorFVG);

  const monedaSimbolo = simuladorFVG.moneda === 'S' ? 'S/ ' : 'US$ ';

  useEffect(() => {
    if (simuladorFVG.idSimulacion === 0) {
      history('/datosPersonales');
    }

    dispatch(getParametrosSimulacion());
  }, [simuladorFVG.idSimulacion, dispatch, history]);

  useEffect(() => {
    const handlePopState = () => {
      borrarConsultarDatos();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  });

  const borrarConsultarDatos = () => {
    dispatch(resetConsultarDatos());
  };

  return (
    <Fragment>
      {mostrarModalCorreo ? (
        <ModalConfirmarCorreoComponent onClose={setMostrarModalCorreo} />
      ) : null}
      {mostratModalNotasI ? (
        <ModalNotasImportantesComponent onClose={setMostratModalNotasI} />
      ) : null}
      <LayoutSimuladorComponent
        laoding={simuladorFVG.status === 'loading'}
        title={'Datos Personales'}
        desc={'Paso 2 de 2'}
        info={'2/2'}
        indice={2}
        action={() => history('/datosPersonales')}
        body={
          <div className={classes()}>
            <p className={classes('simuladorFVGTitle')}>
              <b>Hola {capitalizarPalabras(simuladorFVG.nombre)},</b>
            </p>
            <p className={classes('simuladorFVGSubTitle')}>
              Con este simulador podrás conocer el rendimiento esperado de tu
              inversión ¡Explora!
            </p>
            <br />
            <div className={classes('simuladorFVG_div_1')}>
              <div className={classes('simuladorFVG_div')}>
                <div>
                  <p className={classes('simuladorFVG_text')}>
                    <b>Simula tu Seguro Fondo Vida Garantizado</b>
                  </p>
                </div>
                <div>
                  <p className={classes('simuladorFVG_text_fecha')}>
                    Fecha de cotización
                  </p>
                  <p className={classes('simuladorFVG_text_fecha')}>
                    {obtenerFechaActual()}
                  </p>
                </div>
              </div>
            </div>
            <div className={classes('simuladorFVG_div_2')}>
              <MonedaSelectComponent />
              <br />
              <MontoInputComponent />
              <br />
              <PlazoInputComponent />
            </div>
            <div className={classes('simuladorFVG_div_3')}>
              <div className={classes('simuladorFVG_div')}>
                <div>
                  <p className={classes('simuladorFVG_text')}>
                    Tasa de rendimiento anual
                  </p>
                </div>
                <div className={classes('divIcoTooltip')}>
                  <p className={classes('simuladorFVG_text_det')}>
                    {simuladorFVG.tasaRendimiento}%
                  </p>
                  <TooltipComponent
                    disable={false}
                    id={'rendimiento'}
                    text={
                      'La tasa de rendimiento puede variar según el monto de inversión, la edad del asegurado y la fecha de cotización.'
                    }
                  />
                </div>
              </div>
              <br />
              <div className={classes('simuladorFVG_div')}>
                <div>
                  <p className={classes('simuladorFVG_text')}>
                    % de devolución
                  </p>
                </div>
                <div className={classes('divIcoTooltip')}>
                  <p className={classes('simuladorFVG_text_det')}>
                    {simuladorFVG.porcentajeDevolucion}%
                  </p>
                  <TooltipComponent disable={true} />
                </div>
              </div>
              <br />
              <div className={classes('simuladorFVG_div')}>
                <div>
                  <p className={classes('simuladorFVG_text')}>
                    Rentabilidad obtenida
                  </p>
                </div>
                <div className={classes('divIcoTooltip')}>
                  <p className={classes('simuladorFVG_text_det')}>
                    <b>
                      {monedaSimbolo}{' '}
                      {formatAmount(simuladorFVG.rentabilidadObtenida + '')}
                    </b>
                  </p>
                  <TooltipComponent
                    disable={false}
                    id={'ganancia'}
                    text={
                      'Las ganancias obtenidas del Seguro Fondo Vida Garantizado se encuentran exoneradas del pago de impuesto a la renta.'
                    }
                  />
                </div>
              </div>
            </div>
            <div className={classes('simuladorFVG_div_4')}>
              <div className={classes('simuladorFVG_div')}>
                <div>
                  <p className={classes('simuladorFVG_text_tit_det')}>
                    <b>
                      En{' '}
                      {parseInt(simuladorFVG.plazo) === 1
                        ? '1 año'
                        : `${simuladorFVG.plazo} años`}
                      , recibirás
                    </b>
                  </p>
                </div>
                <div className={classes('divIcoTooltip')}>
                  <p className={classes('simuladorFVG_text_tit_detalle')}>
                    <b>
                      {monedaSimbolo}{' '}
                      {formatAmount(simuladorFVG.montoARecibir + '')}
                    </b>
                  </p>
                  <TooltipComponent disable={true} />
                </div>
              </div>
              <br />
              <div className={classes('simuladorFVG_div')}>
                <div>
                  <p className={classes('simuladorFVG_text')}>Seguro de vida</p>
                  <p className={classes('simuladorFVG_sub_text')}>
                    ({process.env.REACT_APP_COBERTURA_FALLECIMIENTO}% de la
                    devolución)
                  </p>
                </div>
                <div className={classes('divIcoTooltip')}>
                  <p className={classes('simuladorFVG_text_det')}>
                    <b>
                      {monedaSimbolo}{' '}
                      {formatAmount(simuladorFVG.coberturaFallecimiento + '')}
                    </b>
                  </p>
                  <TooltipComponent
                    disable={false}
                    id={'seguro'}
                    text={
                      'En caso de fallecimiento del asegurado, los beneficiarios elegidos recibirán este monto como Seguro de Vida.'
                    }
                  />
                </div>
              </div>
            </div>
            <br />
            <div className={classes('simuladorFVGButtons')}>
              <LinkComponent
                img={ico_description}
                title={'Notas importantes'}
                action={() => setMostratModalNotasI(!mostratModalNotasI)}
              />
              <LinkComponent
                img={ico_inventory}
                title={'Conoce tu cobertura aquí'}
                action={() => window.open(PDF_Coberturas_FVG)}
              />
              {simuladorFVG.idCotizacion ? (
                <ButtonIconComponent
                  img={ico_mail}
                  nombre={'Enviar simulación a tu correo'}
                  label={'btnEnviarSimulacion'}
                  tipo={'button-white'}
                  disabled={false}
                  action={() => setMostrarModalCorreo(true)}
                />
              ) : null}
            </div>
          </div>
        }
      />
    </Fragment>
  );
};

export default SimuladorFVG;
